import cx from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React, { useRef } from "react";

import { useLexicon } from "../context/LexiconContext";
import { trackCustomEvent } from "../utilities/analytics";
import InternalLink from "./InternalLink";
import Nav from "./Nav";

type Props = {
  homePath: string;
  brandLogoDescription: string;
  brandLogoImage: IGatsbyImageData;
  absolutePath: string;
  className?: string;
};

export default function Header({
  homePath,
  brandLogoImage,
  brandLogoDescription,
  absolutePath,
  className,
}: Props) {
  const lexicon = useLexicon();

  const trackHamburgerClickedOpen = () => {
    trackCustomEvent({
      category: "Engagement",
      action: "Click",
      label: "Hamburger Icon (Open)",
    });
  };

  const navToggleRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        type="checkbox"
        id="nav-toggle"
        tabIndex={-1}
        ref={navToggleRef}
        onChange={(e) => {
          if (!navToggleRef.current) {
            return;
          }
          if (navToggleRef.current.checked) {
            document.body.classList.add("unscrollable");
          } else {
            document.body.classList.remove("unscrollable");
          }
          if (e.target.checked) {
            trackHamburgerClickedOpen();
          }
        }}
      />
      <div className="z-50 w-full h-full bg-white header-wrapper">
        <header className={cx(className, "min-h-[6rem]")}>
          <div data-cy="logo" className="logo-wrapper">
            <InternalLink
              href={homePath}
              className="flex mr-auto flex-0 header-logo"
            >
              <GatsbyImage
                image={brandLogoImage}
                alt={brandLogoDescription || ""}
                loading="eager"
              />
              <span className="sr-only">{lexicon.home}</span>
            </InternalLink>
          </div>
          <Nav
            absolutePath={absolutePath}
            navToggleRef={navToggleRef}
            trackHamburgerClickedOpen={trackHamburgerClickedOpen}
          />
        </header>
      </div>
    </>
  );
}
